import * as React from 'react';
import '../../styles/Header.css';
import { Link } from 'react-router-dom';
import * as identity from '../../utilities/identity';
import { browserHistory } from '../../utilities/history';
import { RouteComponentProps, withRouter } from 'react-router';
import { Roles } from '../../utilities/Enums';
import { HeaderLink } from './HeaderLink';
import { formatPhoneNumber } from '../../utilities/Utils';
import { tour24PhoneNumber } from '../../data/constants';
import { NewAdminUrls } from '../../api/Shared';

 const permission = identity.getMyPermissions();
 const canNotSeeManage =
 permission === Roles.CompanyManageUser || permission === Roles.PropertyManageUser || permission === Roles.SystemManageUser;
 console.log("permission: ",permission);
 console.log("canNotSeeManage: ",canNotSeeManage);

 const requiredPermissions = {
    analytics: [
        'PropertyAnalyticsUser',
        'CompanyAnalyticsUser',
        'SystemAnalyticsUser',
        'PropertyAnalyticsAdmin',
        'CompanyAnalyticsAdmin',
        'SystemAnalyticsAdmin',
    ],
    dashboard: [
        'PropertyDashboardUser',
        'PropertyDashboardAdmin',
        'CompanyDashboardUser',
        'CompanyDashboardAdmin',
        'SystemDashboardUser',
        'SystemDashboardAdmin',
    ],
    manage: [
        'PropertyManageAdmin',
        'PropertyManageUser',
        'CompanyManageUser',
        'CompanyManageAdmin',
        'SystemManageUser',
        'SystemManageAdmin',
    ],
};

const hasPermission = (requiredPermissions: string[]) => {
    const permissionList = identity.getMyPermissions() || [];
    return requiredPermissions.some(permission => permissionList.includes(permission));
};


const logoColor = require('../../images/logo-color.png');

export interface Props extends RouteComponentProps<{}> {
    isRegisteredUserFacing: boolean;
    showPhoneNumber: boolean;
}

const Header = (props: Props) => {
    const logOut = () => {
        identity.clearToken();
        browserHistory.push('/login');
    };

    const role = identity.getMyRole();
    const canSeeManage =
        role === Roles.SystemAdmin || role === Roles.CompanyAdmin || role === Roles.PropertyAdmin;

    return (
        <header className="header">
           {/* Banner Section */}
           <div className="banner" style={{ backgroundColor: '#27bbf9', textAlign: 'center', padding: '10px 10px 10px', margin: '0', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
  <a href={`${NewAdminUrls.NEW_ADMIN_URL}/login`} target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF', fontWeight: 'bold', textDecoration: 'none' }}>
    Try the new Tour24 Explore Platform (Beta) and give us your feedback
  </a>
</div>

            <div className="mx-5 d-flex justify-content-between" 
            style={{ paddingTop: '30px' }}
            >
                {props.isRegisteredUserFacing ? (
                    <Link to="/" className="mr-auto">
                        <img src={logoColor} className="tour24-logo-admin" />
                    </Link>
                ) : (
                    <img className="mr-auto tour24-logo-admin" src={logoColor} />
                )}
                {props.isRegisteredUserFacing &&
                    (identity.isAuthenticated() ? (
                        <div className="btn-group" style={{ flexWrap: 'wrap' }} role="group">
                            {hasPermission(requiredPermissions.analytics) && canSeeManage && <HeaderLink beta={true} url="/admin/analytics" label="Analytics"/>}
                            {hasPermission(requiredPermissions.dashboard) && <HeaderLink url="/admin/dashboard" label="Dashboard" />}
                            {hasPermission(requiredPermissions.dashboard) && <HeaderLink url="/admin/prospects" label="Prospects" />}

                            {hasPermission(requiredPermissions.manage) && canSeeManage && <HeaderLink url="/admin/manage" label="Manage" />}
                            {/* Commented out the line below satish J */}
                            {/*<HeaderLink newTab={true} url="https://support.tour24.io" label="Support" />*/}
                            <HeaderLink url="/admin/account" label="My Account" />
                            <a
                                className='font-weight-bold nav-link'
                                onClick={logOut}
                            >
                                Logout
                            </a>
                        </div>
                    ) : (
                        <></>
                    ))}
                {!props.isRegisteredUserFacing && props.showPhoneNumber && (
                    <div className=" font-weight-bold phoneNumber float-right">
                        {formatPhoneNumber(tour24PhoneNumber)}
                    </div>
                )}
            </div>
        </header>
    );
};

export default withRouter<Props>(Header);



// WEBPACK FOOTER //
// ./src/components/common/Header.tsx